<template>
  <div>
    <a-spin size="large" :spinning="spinning" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        row-id="id"
        size="small"
        :column-config="{ isHover: true }"
        :row-config="{ height: 35, isCurrent: true, isHover: true }"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        header-align="center"
      >
        <vxe-column
          field="genesymbol"
          title="Gene name"
          width="150px"
          type="html"
        >
          <template #default="{ row }">
            <div style="text-align: center; font-weight: bolder; color: blue">
              <span
                @click="goQuickGene(row.genesymbol)"
                onmouseover="this.style.cursor='pointer'"
              >
                {{ row.genesymbol }}
              </span>
            </div>
          </template>
        </vxe-column>
        <vxe-column
          field="ensemble"
          title="Ensembl ID"
          type="html"
          show-overflow
        ></vxe-column>
        <vxe-column
          field="localization"
          title="Subcellular localizations"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'Main subcellular location of proteins based on immunofluorescently stained cells from The Human Protein Atlas',
          }"
          type="html"
        ></vxe-column>
        <vxe-column field="datasetID" title="Perturb-Seq IDs" type="html">
          <template #default="{ row }">
            <div style="text-align: center">
              <div
                v-for="(index, element) in row.datasetID.split(',')"
                :key="index"
                :value="element"
              >
                <a
                  @click="goDataset(index, row.genesymbol)"
                  style="color: blue"
                >
                  {{ index }}</a
                >
              </div>
            </div>
          </template>
        </vxe-column>
        <vxe-column
          field="bulkSeq"
          title="Bulk perturbation RNA-Seq IDs"
          type="html"
        >
          <template #default="{ row }">
            <div style="text-align: center" v-if="row.bulkSeq != null">
              <div
                v-for="(index, element) in row.bulkSeq.split(',')"
                :key="index"
                :value="element"
              >
                <a
                  @click="goDatasetBulk(index, row.genesymbol)"
                  style="color: blue"
                >
                  {{ index }}</a
                >
              </div>
            </div>
            <div style="text-align: center" v-if="row.bulkSeq == null"></div>
          </template>
        </vxe-column>
        <vxe-column
          field="clusters"
          title="Perturbation cluster IDs"
          type="html"
        >
          <template #default="{ row }">
            <div
              v-if="
                row.clusters !== null &&
                row.clusters !== '' &&
                row.clusters !== '-'
              "
              style="text-align: center"
            >
              <div
                v-for="(index, element) in row.clusters.split(',')"
                :key="index"
                :value="element"
              >
                <a-tag
                  color="#4572a7"
                  style="margin-bottom: 2px"
                  @click="goTOpc(index)"
                >
                  {{ index }}</a-tag
                >
              </div>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="genetype" title="Gene types" type="html">
          <template #default="{ row }">
            <div style="text-align: center" v-if="row.genetype != null">
              <div
                v-for="(index, element) in row.genetype.split(',')"
                :key="index"
                :value="element"
              >
                <a-tag
                  v-if="index == 'RBP'"
                  color="pink"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'TF'"
                  color="red"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'Metabolism'"
                  color="orange"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'Essential'"
                  color="green"
                  style="margin-bottom: 2px"
                >
                  Essential gene
                </a-tag>
                <!-- <a-tag
                v-if="index == 'E3'"
                color="cyan"
                style="margin-bottom: 2px"
              >
                {{ index }}
              </a-tag> -->
              </div>
            </div>
          </template>
        </vxe-column>
        <template #empty>
          <span style="color: grey"> No records found! </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[50, 75, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  // components: { downloadexcel },
  props: ["choosepathway"],
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 50,
        totalResult: 0,
      },
    };
  },
  watch: {
    filterName_detable() {
      console.log(this.filterName_detable);
      if (this.filterName_detable != "") {
        axios
          .get(this.webiste + "/API/publications_deTable.php", {
            params: {
              datasetId: this.$route.query.datasetId,
              gene: this.filterName_detable,
            },
          })
          .then((response) => {
            this.getdata_detable = response.data;
            this.findList_detable(this.getdata_detable);
            this.loading = false;
          });
      } else {
        axios
          .get(this.webiste + "/API/publications_deTable.php", {
            params: {
              datasetId: this.$route.query.datasetId,
              gene: " ",
            },
          })
          .then((response) => {
            this.getdata_detable = response.data;
            this.findList_detable(this.getdata_detable);
            this.loading = false;
          });
      }
    },
  },
  created() {
    axios
      .get(this.webiste + "/API/search/geneclassifier.php")
      .then((response) => {
        // var filterData = response.data.filter(function (item) {
        //   return item.datasetID !== "";
        // });
        this.getdata_detable = response.data;
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },

  methods: {
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "All_perturbed_gene_in_PerturbDB",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.filterName_detable + "_related_perturbed_gene_in_PerturbDB",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goQuickGene(value) {
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
      this.value = "";
    },
    goQuickSearch(value) {
      let href = this.webiste + "/#/quickSearch?gene=" + value;
      window.open(href, "_blank");
    },
    goTOpc(value) {
      let href = this.webiste + "/#/pcDetails?pcID=" + value;
      window.open(href, "_blank");
    },
    goDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    goDatasetBulk(value, value2) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "genesymbol",
          "ensemble",
          "genetype",
          "datasetID",
          "clusters",
          "localization",
        ];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        // 必须装回来
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
</style>
